import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_Usages_V3_UsagesModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetUsagesV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  interval?: string;
  aggregation?: string;
  start?: string;
  end?: string;
  extrapolate?: boolean;
  addWeather?: boolean;
  addPreviousYear?: boolean;
  addBudget?: boolean;
};
/**
 * Returns the new Usages V3 variant model of the usage data.
This now works with ranges, aggregation and interval levels and for customers that switched between dynamic and fixed contracts.
 * 
 * @returns ResponseModels_Usages_V3_UsagesModel Success
 */
export function getUsagesV3(
  {
    businessUnit,
    label,
    customerId,
    accountId,
    interval,
    aggregation,
    start,
    end,
    extrapolate,
    addWeather,
    addPreviousYear,
    addBudget,
  }: GetUsagesV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_V3_UsagesModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/v3/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/usages`,
      query: { interval, aggregation, start, end, extrapolate, addWeather, addPreviousYear, addBudget },
      errors: { 400: 'Bad Request', 404: 'Not Found', 500: 'Server Error' },
    },
    requestConfig,
  );
}
